'use strict';

angular.module('eva2-angular').filter('min', function() {
  return function(a, b) {
    return Math.min(a, b);
  };
});
